// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3U6Y4","unreadBadge":"styles_unreadBadge__Ms-ks","modalContent":"styles_modalContent__3EqT4","modal":"styles_modal__VzS2W"};